import { render, staticRenderFns } from "./AppointmentManagement.vue?vue&type=template&id=4c5ef669&scoped=true"
import script from "./AppointmentManagement.vue?vue&type=script&lang=js"
export * from "./AppointmentManagement.vue?vue&type=script&lang=js"
import style0 from "./AppointmentManagement.vue?vue&type=style&index=0&id=4c5ef669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ef669",
  null
  
)

export default component.exports